import React from "react";
import { FieldConfig } from "./FieldConfig";

export interface FormFieldConfigContextProps {
  fieldConfig: FieldConfig;
  errorMessagesCount?: number;
  showRequiredFieldAsterisk?: boolean;
}

export const FormFieldConfigContext = React.createContext<
  FormFieldConfigContextProps | undefined
>(undefined);
